import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_CUSAT_BY_ID } from 'constants/api';
import { generateURL } from 'helpers';
import { storeName } from '../config';
import { CusatDataItem, CusatDataPayload } from '../interfaces';

export const updateCusat = createAsyncThunk<
  CusatDataItem,
  { id: number; data: CusatDataPayload }
>(`${storeName}/update`, async ({ id, data }, thunkAPI) =>
  api.axios
    .put(generateURL(API_CUSAT_BY_ID, { id }), data)
    .then((res) => res.data)
    .catch((e) => thunkAPI.rejectWithValue(e.response?.data)),
);
